import { EmptyState } from '@tpct/admin-ui';
import { __ } from '@/hub-shared/utils/i18n';
import type { PortalBootstrapData } from './types/window';
import NotificationInboxTab from './tabs/NotificationInboxTab';

type NotificationsPageProps = {
  bootstrap: PortalBootstrapData;
  onSessionExpired: () => void;
  onUnreadCountChange?: (count: number) => void;
};

const NotificationsPage = ({
  bootstrap,
  onSessionExpired,
  onUnreadCountChange,
}: NotificationsPageProps) => {
  const hasCabinet =
    bootstrap.cabinetId !== null && bootstrap.cabinetId !== undefined && bootstrap.cabinetId > 0;

  if (!hasCabinet) {
    return (
      <EmptyState
        title={__('Notifications indisponibles')}
        description={__(
          'Ce compte n’est pas rattaché à un cabinet. Les notifications sont disponibles pour les utilisateurs cabinet.',
        )}
      />
    );
  }

  return (
    <section className="notifications-page">
      <h2 className="h4">{__('Notifications')}</h2>
      <NotificationInboxTab
        bootstrap={bootstrap}
        onSessionExpired={onSessionExpired}
        onUnreadCountChange={onUnreadCountChange}
      />
    </section>
  );
};

export default NotificationsPage;
